import { create } from "zustand";

const isBrowser = typeof window !== "undefined"

const initialCounter = 0

const initialCartItems = []

export const useUser = create((set) => ({
  cartItemsCounter: initialCounter,
  cartItems: initialCartItems,

  fetch: () => {
    if(isBrowser) {

      const localCart = JSON.parse(window.localStorage.getItem("cart"));


      const localCounter= window.localStorage.getItem("cartCounter");

      if (!localCart) return;

      set({ cartItems: localCart, cartItemsCounter: localCounter});
    }
  },
  setInitialState: () => set(_ => {
    window.localStorage.setItem("cart",JSON.stringify(initialCartItems));
    window.localStorage.setItem("cartCounter",initialCounter);
    return {
      cartItems: initialCartItems, cartItemsCounter: initialCounter
    };

  }),
  addItemToCart: ({id, quantity, productName, price, image}) => set((state) => {
    let newCartItems= state.cartItems

    const indexOf= newCartItems.findIndex(item=>item.id === id)

    if(indexOf >= 0) newCartItems[indexOf].quantity+=quantity

    else newCartItems.push({id, productName, price,  quantity, image})
    
    if(isBrowser) {
      window.localStorage.setItem("cart",JSON.stringify(newCartItems));
      window.localStorage.setItem("cartCounter",state.cartItemsCounter + quantity);
    }
    if(quantity === 0) this.removeItemFromCart(id)
    
    return {
      cartItems: newCartItems, cartItemsCounter: state.cartItemsCounter + quantity
    };

  }),
  handleQuantity: ({id, quantity}) => set((state) => {
    let newCartItems= state.cartItems

    const indexOf= newCartItems.findIndex(item=>item.id === id)

    if(indexOf >= 0) newCartItems[indexOf].quantity=quantity
    
    const cartCounter= newCartItems.map(a=>a.quantity).reduce((a,b)=>a+b)

    if(isBrowser) {
      window.localStorage.setItem("cart",JSON.stringify(newCartItems));
      window.localStorage.setItem("cartCounter",cartCounter);
    }
    
    return {
      cartItems: newCartItems, cartItemsCounter: cartCounter
    };

  }),
  removeItemFromCart: (id) => set((state) => {
    
    const newCartItems= state.cartItems.filter(item=>item.id !== id)
    
    const cartCounter= newCartItems.map(a=>a.quantity).reduce((a,b)=>a+b)

    if(isBrowser){
      window.localStorage.setItem("cart",JSON.stringify(newCartItems));
      window.localStorage.setItem("cartCounter", cartCounter);
    }

    return {
      cartItems: newCartItems, cartItemsCounter: cartCounter
    };
  }),
}));
